import {Component, OnInit} from '@angular/core';
import {FormComponent} from '@ngx-ivengi/crud';
import {PictureService} from './picture.service';
import {UIRouter} from '@uirouter/angular';
import {Picture} from './picture.model';
import {TranslateService} from '@ngx-translate/core';
import {FileService} from '../file/file.service';

@Component({
  selector: 'app-picture-form',
  templateUrl: './picture-view.component.html'
})
export class PictureViewComponent implements OnInit {
  public picture: Picture = new Picture();
  public stateIdParam: string = 'pictureId';

  constructor(
    protected router: UIRouter,
    private pictureService: PictureService,
    private translate: TranslateService,
    private fileService: FileService,
  ) {}

  public ngOnInit(): void {
    this.pictureService.get(this.router.stateService.params[this.stateIdParam]).map((picture) => {
      picture.setFileSrc(this.fileService.getLinkById(picture.fileId));
      return picture;
    }).subscribe((picture) => {
      this.picture = picture;
    });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/picture/picture-view.component.ts